/* survival-analysis.ts */

export enum StartPointType {
  FIRST_DIAGNOSIS = "First diagnosis",
  FIRST_TREATMENT_LINE = "First treatment line",
  SECOND_TREATMENT_LINE = "Second treatment line",
}
